// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetLayoutsCatalogRequest, TGetLayoutsCatalogModel, IMappers, TGetLayoutsCatalogResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetLayoutsCatalogResponse } from '../../entities/get_layouts_catalog/GetLayoutsCatalogResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetLayoutsCatalogModel(parameters: TGetLayoutsCatalogRequest): TGetLayoutsCatalogModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-layouts-catalog/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetLayoutsCatalogOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetLayoutsCatalogRequest;
}

export async function fetchGetLayoutsCatalog<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetLayoutsCatalogOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetLayoutsCatalogResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetLayoutsCatalogModel(parameters),
    config,
  )) as FetchResponse<TGetLayoutsCatalogResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetLayoutsCatalogResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetLayoutsCatalogResponse>;
}
